module.exports = __webpack_public_path__ + "static/media/Gopi.ee32a105.webp";